module.exports = __webpack_public_path__ + "img/01.e7aa8842.jpg";